import collect from './collect'
import referrer from './referrer'
import relation from './relation'
import visit from './visit'
import notice from './notice'
import sensitive from './sensitive'
import repeat from './repeat'
import configIndex from './configIndex'
import service from './service'
import logo from './logo'
import ocpc from './ocpc'
import smart from './smart'
import allocationrule from './allocationrule'
import batchImport from './import'
import setlist from './setlist'
import webhook from './webhook'
import xiaoman from './xiaoman/index'
import autoWithdraw from './autoWithdraw'
import tv from './tv'
import clue from './clue'
import listview from './listview'
import relativeProject from './relativeProject'

export default {
  namespaced: true,
  modules: {
    collect,
    referrer,
    relation,
    visit,
    notice,
    sensitive,
    repeat,
    configIndex,
    service,
    logo,
    ocpc,
    smart,
    allocationrule,
    batchImport,
    setlist,
    webhook,
    xiaoman,
    autoWithdraw,
    tv,
    clue,
    listview,
    relativeProject
  }
}
